import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-2 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.metaData')))])]), _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.title') + '*',
      "color": _vm.color,
      "rules": _vm.titleRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "consumerTitle",
      "required": ""
    },
    model: {
      value: _vm.lclObject.title,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject, "title", $$v);
      },
      expression: "lclObject.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.titleHint')) + "\n        "), _c('br'), _vm.lclObject.account ? _c('span', [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.accHint')) + " " + _vm._s(_vm.lclObject.account.name) + "\n        ")]) : _vm._e()])], 1), _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": "",
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.type') + '*',
      "color": _vm.color,
      "rules": _vm.titleRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "consumerType",
      "required": ""
    },
    model: {
      value: _vm.lclObject.type,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject, "type", $$v);
      },
      expression: "lclObject.type"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.typeHint')))])], 1), _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c(VTextarea, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": "",
      "name": "consumerDescription",
      "hide-details": ""
    },
    model: {
      value: _vm.lclObject.description,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject, "description", $$v);
      },
      expression: "lclObject.description"
    }
  })], 1), _vm.lclObject.type === 'Webhook' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.webhookUrl') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "webhook_url",
      "required": ""
    },
    model: {
      value: _vm.lclObject.webhook_url,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject, "webhook_url", $$v);
      },
      expression: "lclObject.webhook_url"
    }
  })], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "6",
      "md": "2",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.port'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "Port"
    },
    model: {
      value: _vm.lclObject.options.port,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "port", $$v);
      },
      expression: "lclObject.options.port"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.iec104_port')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "6",
      "md": "2",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.kValue') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "kValue",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.kValue,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "kValue", $$v);
      },
      expression: "lclObject.options.kValue"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.k_value')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "6",
      "md": "2",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.wValue') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "wValue",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.wValue,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "wValue", $$v);
      },
      expression: "lclObject.options.wValue"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.w_value')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "6",
      "md": "2",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.t1Timeout') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "t1",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.t1,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "t1", $$v);
      },
      expression: "lclObject.options.t1"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.iec104_t1')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "6",
      "md": "2",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.t2Timeout') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "t2",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.t2,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "t2", $$v);
      },
      expression: "lclObject.options.t2"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.iec104_t2')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "6",
      "md": "2",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.t3Timeout') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "t3",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.t3,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "t3", $$v);
      },
      expression: "lclObject.options.t3"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.iec104_t3')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "6",
      "md": "2",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.pollingInt'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "dataPollingInterval"
    },
    model: {
      value: _vm.lclObject.options.dataPollingInterval,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "dataPollingInterval", $$v);
      },
      expression: "lclObject.options.dataPollingInterval"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.dataPollingInterval')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "2"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": "",
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.configId'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "configId"
    },
    model: {
      value: _vm.lclObject.externalId,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject, "externalId", $$v);
      },
      expression: "lclObject.externalId"
    }
  })], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c(VSwitch, {
    staticClass: "pt-0",
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.allowAnons')
    },
    model: {
      value: _vm.lclObject.options.allowAnonymousClients,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "allowAnonymousClients", $$v);
      },
      expression: "lclObject.options.allowAnonymousClients"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.allowAnonymousClients')))])], 1) : _vm._e(), _vm.lclObject.type === 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "2"
    }
  }, [_c(VSwitch, {
    staticClass: "pt-0",
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.serverTz')
    },
    model: {
      value: _vm.lclObject.options.utc,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "utc", $$v);
      },
      expression: "lclObject.options.utc"
    }
  })], 1) : _vm._e(), _vm.lclObject.type === 'Azure' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.azureSensorId') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "azureSensorId",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.azureSensorId,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "azureSensorId", $$v);
      },
      expression: "lclObject.options.azureSensorId"
    }
  })], 1) : _vm._e(), _vm.lclObject.type === 'Azure' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.azureHostName') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "hostName",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.hostName,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "hostName", $$v);
      },
      expression: "lclObject.options.hostName"
    }
  })], 1) : _vm._e(), _vm.lclObject.type === 'Azure' ? _c(VCol, {
    staticClass: "pb-2",
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.isIotHubManager || _vm.cloading,
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.sharedAccessKey') + '*',
      "rules": _vm.titleRules,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "name": "sharedAccessKey",
      "required": ""
    },
    model: {
      value: _vm.lclObject.options.sharedAccessKey,
      callback: function ($$v) {
        _vm.$set(_vm.lclObject.options, "sharedAccessKey", $$v);
      },
      expression: "lclObject.options.sharedAccessKey"
    }
  })], 1) : _vm._e(), _vm.lclObject.type != 'IEC-60870-5-104' ? _c(VCol, {
    staticClass: "pb-0 pt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.dataTransDetails')))])]) : _vm._e(), _c(VCol, {
    staticClass: "pb-0 pt-2",
    attrs: {
      "md": "4",
      "lg": "3"
    }
  }, [_vm.lclObject.type === 'Websocket' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2",
      "height": "150"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.serverN20')) + "\n            ")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.wssConKey')) + "\n            ")]), _c(VListItemSubtitle, [_vm._v("\n              " + _vm._s(_vm.lclObject.apiKey) + "\n            ")])], 1)], 1)], 1) : _vm._e(), _vm.lclObject.type === 'MQTT' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2",
      "height": "150"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.brokerN20')) + "\n            ")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.secret')) + "\n            ")]), _c(VListItemSubtitle, [_vm._v("\n              " + _vm._s(_vm.lclObject.apiKey) + "\n            ")])], 1)], 1)], 1) : _vm._e(), _vm.lclObject.type === 'Webhook' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2",
      "height": "150"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.whN20')) + "\n            ")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.url')) + "\n            ")]), _c(VListItemSubtitle, [_vm._v("\n              " + _vm._s(_vm.lclObject.webhook_url) + "\n            ")])], 1)], 1)], 1) : _vm._e(), _vm.lclObject.type === 'Azure' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2",
      "height": "150"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.clN20')) + "\n            ")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.apiKey')) + "\n            ")]), _c(VListItemSubtitle, [_vm._v("\n              " + _vm._s(_vm.lclObject.apiKey) + "\n            ")])], 1)], 1)], 1) : _vm._e()], 1), _c(VCol, {
    staticClass: "pb-0 pt-2",
    attrs: {
      "md": "1",
      "lg": "1"
    }
  }, [_vm.lclObject.type === 'Websocket' || _vm.lclObject.type === 'MQTT' || _vm.lclObject.type === 'Webhook' || _vm.lclObject.type === 'Azure' ? _c(VProgressLinear, {
    staticStyle: {
      "margin-top": "75px"
    },
    attrs: {
      "color": _vm.color,
      "buffer-value": "0",
      "indeterminate": "",
      "stream": ""
    }
  }) : _vm._e()], 1), _c(VCol, {
    staticClass: "pb-0 pt-2 mb-0",
    attrs: {
      "md": "7",
      "lg": "8"
    }
  }, [_vm.lclObject.type === 'Websocket' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.client')) + "\n            ")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.webApp')) + "\n            ")]), _c(VListItemSubtitle, [_c('span', {
    ref: "mobile-web-link"
  }, [_vm._v("\n                " + _vm._s(`wss://${_vm.n1Host}/api/x/websocket/consumers/${_vm.lclObject.id}?auth=${_vm.lclObject.apiKey}`) + "\n              ")]), _c(VIcon, {
    staticClass: "ml-1",
    attrs: {
      "size": "16",
      "title": _vm.$i18n_t('Common.copy')
    },
    on: {
      "click": function ($event) {
        return _vm.copyToClipboard('mobile-web-link');
      }
    }
  }, [_vm._v("\n                fal fa-copy\n              ")])], 1)], 1), _c(VListItemAvatar, {
    attrs: {
      "tile": "",
      "size": "40"
    }
  }, [_vm.wsconnected ? _c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-link")]) : _c(VIcon, {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("fal fa-unlink")])], 1)], 1), _c(VCardText, [_c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-1",
    attrs: {
      "options": _vm.cmOptions
    },
    model: {
      value: _vm.lclObjectStr,
      callback: function ($$v) {
        _vm.lclObjectStr = $$v;
      },
      expression: "lclObjectStr"
    }
  })], 1)], 1) : _vm._e(), _vm.lclObject.type === 'MQTT' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.mqttClient')) + "\n            ")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.mqttClientHint')) + "\n            ")]), _c(VListItemSubtitle, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.mqttClientHint2')) + "\n            ")])], 1)], 1), _c(VCardText, [_c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-1",
    attrs: {
      "options": _vm.cmOptions
    },
    model: {
      value: _vm.lclObjectStr,
      callback: function ($$v) {
        _vm.lclObjectStr = $$v;
      },
      expression: "lclObjectStr"
    }
  })], 1)], 1) : _vm._e(), _vm.lclObject.type === 'Webhook' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2",
      "height": "150"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.whServer')) + "\n            ")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.whServerHint')) + "\n            ")])], 1), _c(VListItemAvatar, {
    attrs: {
      "tile": "",
      "size": "40"
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-globe")])], 1)], 1)], 1) : _vm._e(), _vm.lclObject.type === 'Azure' ? _c(VCard, {
    attrs: {
      "outlined": "",
      "elevation": "2",
      "height": "150"
    }
  }, [_c(VListItem, {
    attrs: {
      "three-line": ""
    }
  }, [_c(VListItemContent, [_c('div', {
    staticClass: "text-overline mb-4"
  }, [_vm._v("MS Azure")]), _c(VListItemTitle, {
    staticClass: "font-weight-medium mb-1"
  }, [_vm._v("\n              IoT Hub " + _vm._s(_vm.lclObject.options.hostName) + "\n            ")]), _c(VListItemSubtitle, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.azureSensorId')) + ":\n              "), _c('b', [_vm._v(_vm._s(_vm.lclObject.options.azureSensorId))]), _vm._v("\n              || " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.sharedAccessKey')) + ":\n              "), _c('b', [_vm._v(_vm._s(_vm.lclObject.options.sharedAccessKey))])])], 1), _c(VListItemAvatar, {
    attrs: {
      "tile": "",
      "size": "40"
    }
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color
    }
  }, [_vm._v("fal fa-globe")])], 1)], 1)], 1) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VDivider)], 1), _vm.lclObject.type != 'IEC-60870-5-104' ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-applications"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-tachometer-alt")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.config')) + "\n        ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-jsontrafo"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-file-alt")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.jsonTrafo')) + "\n        ")], 1)], 1), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "applications",
    attrs: {
      "value": "tab-applications"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": null,
      "buttons": _vm.applButtons,
      "offset": "30"
    },
    on: {
      "addAppl": _vm.addAppl
    }
  }, [_c('niota-classic-consumers-appl-table', {
    ref: "applTable",
    staticClass: "mt-2",
    attrs: {
      "applications": _vm.lclObject.applications
    }
  })], 1)], 1), _c(VTabItem, {
    key: "jsontrafo",
    attrs: {
      "value": "tab-jsontrafo"
    }
  }, [_c('niota-classic-consumers-json-trafo', {
    ref: "jsonTrafo",
    staticClass: "mt-2",
    attrs: {
      "jsontr": _vm.lclObject.options
    },
    on: {
      "jsonTrafoChanged": _vm.jsonTrafoChanged
    }
  })], 1)], 1)], 1) : _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-1"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-tachometer-alt")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.iecSettings')) + "\n        ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-2"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-file-alt")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.metrics')) + "\n        ")], 1)], 1), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "1",
    attrs: {
      "value": "tab-1"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": null,
      "buttons": _vm.dpButtons,
      "offset": "30"
    },
    on: {
      "addDp": _vm.addDp
    }
  }, [_c('niota-classic-consumers-data-Points', {
    ref: "dpsTable",
    staticClass: "mt-2",
    attrs: {
      "dataPoints": _vm.lclObject.options.dataPoints,
      "dense": ""
    }
  })], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('core-n20Card', {
    staticClass: "dt-card-text-01",
    attrs: {
      "title": null,
      "buttons": _vm.ipButtons,
      "offset": "30"
    },
    on: {
      "addIp": _vm.addIp
    }
  }, [_c('niota-classic-consumers-ip-white-list', {
    ref: "ipsTable",
    staticClass: "mt-2",
    attrs: {
      "ips": _vm.lclObject.options.clientWhitelist,
      "dense": ""
    }
  })], 1)], 1)], 1)], 1), _c(VTabItem, {
    key: "2",
    attrs: {
      "value": "tab-2"
    }
  }, [_c('niota-classic-consumers-iec104-metrics', {
    ref: "iec104metrics",
    staticClass: "mt-2",
    attrs: {
      "consumer": _vm.lclObject
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };